module.exports = {
    "title": "Redcap Deploy",
    "entityName": "redcap_deploy",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    "fields": [
        {
            "value": "sponsor_id",
            "text": "Sponsor",
            "type": "list",
            "table": {
                "sortable": true,
                "filter": true
            },
            list: [{id:1, text:'EMN Trial Office'},{id:2, text:'EMN Italy'},{id:4, text:'EMN International'}],
            id: 'id',
            title:'text',
            render: (item) => {
                return item.sponsor.name
            }
        },

        {
            "value": "name",
            "text": "Name",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required",
            ]
        },

        {
            "value": "is_module",
            "text": "Is Module",
            "type": "check",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                // "required",
            ]
        },

        {
            "value": "folder",
            "text": "Folder",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                // "required",
            ]
        },

        {
            "value": "last_deploy",
            "text": "Last Deploy",
            //ISSUE 149
            filtertofrom: true,
            //ISSUE 149
            "type": "date",
            visible: false,
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required",
            ]
        },

       

    ],
    "actions": [
        { "value": "deploy", "text": "Deploy", "icon": "mdi-cloud-upload", "color": "primary" },
         "upsert", "remove", 
    ]
}